module.exports = __webpack_public_path__ + "img/AV_003_logo_header.0553cc2c.svg";